import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import Collapsable from '../Collapsable'

export const ColabspableContainer = styled(Collapsable)`
  @media print {
    display: none;
  }
`

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;
  text-align: center;

  &::first-letter {
    text-transform: uppercase;
  }

  @media ${mq(sizes.desktop)} {
    text-align: left;
    ${({ theme }) => theme.textStyles.titleH2_30}
  }
`

export const Inner = styled.div`
  margin-top: 3.5rem;
  @media ${mq(sizes.desktop)} {
    margin-top: 2rem;
  }
`
